// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8b99b8c1","769":"cf717040"}[chunkId] + ".chunk.js";
};